import { render } from "./AppTableHead.vue?vue&type=template&id=2dd563b2&scoped=true"
import script from "./AppTableHead.vue?vue&type=script&lang=js"
export * from "./AppTableHead.vue?vue&type=script&lang=js"

import "./AppTableHead.vue?vue&type=style&index=0&id=2dd563b2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dd563b2"]])

export default __exports__